import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useLazyQuery } from "@apollo/client";

import { LIST_TAB_CATEGORIES_AND_SUBCATEGORIES } from "../../NewQuery/EquipmentTab/equipmentQuery";
import * as HomePageTabsAction from "../../NewRedux/HomePageTabs/homepageTabsAction";

export const EquipmentStepper0 = ({ stepperState, setStepperState, setFilterSelectedData, filterSelectedData }) => {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);

  const [columnCountState] = useState(4);

  const category = useSelector(state => state.homepageTabSlice.category);

  const [getTabCategoriesAndSubCategories,
    { loading: tabCategoriesAndSubcategoriesLoading, error: tabCategoriesAndSubcategoriesError, data: tabCategoriesAndSubcategoriesData }] = useLazyQuery(LIST_TAB_CATEGORIES_AND_SUBCATEGORIES, {
    fetchPolicy: "no-cache",
  });

  const setStepperAndFilterData = (filterData) => {
    setStepperState(1);
    setFilterSelectedData((preVal) => ({ ...preVal, category: [filterData] }));
  };

  useEffect(() => {
    if (tabCategoriesAndSubcategoriesData?.getCategoryDataForAssetCategoryType) {
      dispatch(HomePageTabsAction.setTabCategoryList(tabCategoriesAndSubcategoriesData.getCategoryDataForAssetCategoryType));
    }
  }, [tabCategoriesAndSubcategoriesData, tabCategoriesAndSubcategoriesLoading, tabCategoriesAndSubcategoriesError, dispatch]);

  useEffect(() => {
    if (category) {
      let dataArray = [];
      category.map((next, index) => {
        let localArray = [];
        let indexVar = null;
        switch (index % columnCountState) {
        case 0:
          indexVar = 0;
          break;
        case 1:
          indexVar = 1;
          break;
        case 2:
          indexVar = 2;
          break;
        default:
          indexVar = 3;
        }

        if (Array.isArray(dataArray[indexVar])) {
          dataArray[indexVar].push(<div key={`contentMainDivisionKey${index}`}><div className="d-flex justify-content-center align-items-center contentUpperDivision" onClick={() => { setStepperAndFilterData(next.categories); }}>{next.categories.name}</div>
            <div className={"contentLowerDivision"}>{
              next.subCategories.map((value, innerIndex) => {
                return (
                  <div className="d-flex justify-content-center align-items-center contentLowerDivOptions">{value.name}</div>
                );
              })
            }</div>
          </div>);
        }
        else {
          localArray.push(
            <div key={`contentMainDivisionKey${index}`}><div className="d-flex justify-content-center align-items-center contentUpperDivision" onClick={() => { setStepperAndFilterData(next.categories); }}>{next.categories.name}</div>
              <div className={"contentLowerDivision"}>{
                next.subCategories.map((value, innerIndex) => {
                  return (
                    <div className="d-flex justify-content-center align-items-center contentLowerDivOptions">{value.name}</div>
                  );
                })
              }</div>
            </div>,
          );
          dataArray.push(localArray);
        }
      });
      setData(dataArray);
    }
  }, [category]);
  useEffect(() => {
    getTabCategoriesAndSubCategories({
      variables: { assetCategoryClassName: filterSelectedData.tabs[0] },
    });

  }, [filterSelectedData]);

  return (
    <>
      <h3>{filterSelectedData.tabs[0]}</h3>
      <p>Select a category below to continue</p>
      <div className="d-flex flex-wrap scrollableDivision">
        {
          data.length ? data.map((value, index) => {
            return (
              <div className="mainDivision" key={`mainDivisionKey${index}`}>
                {
                  value.map((innerArrayValue) => {
                    return (
                      innerArrayValue
                    );
                  })
                }
              </div>
            );
          }) : null
        }
      </div>
    </>
  );
};
